<app-navbar [PageType]="navType"></app-navbar>
<div class="body-bg">
    <div class="container-first">
        <div class="container-new ">
            <div>
                <div class="top-tittle">Get matched before you apply, with the <span>best rates</span> in the UK</div>
                <div class="text-header">Search over 30 lenders & banks. Compare offers with personalised rates in under 2 minutes. </div>
                <div>
                    <form [formGroup]="OneForm">
                        <div class="box-start d-select">
                            <div class="width-loan-set">
                                <div class="d-flex loan-box-y">
                                    <div class="loan-steps">
                                        <div class="loan-text-y">Loan Purpose</div>
                                        <div class="d-flex margin-y">

                                              <!-- <div class="filter-text">Home Improvements</div> -->
                                              <div class="filter-text"
                                              [ngClass]="PurposeType==PurposeTypeEnum.HomeImprovements?'active-filter':''"
                                              (click)="LoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">Home
                                              Improvements</div>

                                            <!-- <div class="filter-text active-y">Car Loan</div> -->
                                            <div class="filter-text"
                                            [ngClass]="PurposeType==PurposeTypeEnum.CarLoan?'active-filter':''"
                                            (click)="LoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan</div>
                                       
                                        </div>
                                        <div class="d-flex">
                                          
                                                 <!-- <div class="filter-text">Debt Consolidation</div> -->
                                                 <div class="filter-text"
                                                 [ngClass]="PurposeType==PurposeTypeEnum.DebtConsolidation?'active-filter':''"
                                                 (click)="LoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">Debt
                                                 Consolidation</div>
                
                                            <!-- <div class="filter-text">Others</div> -->
                                            <div class="filter-text"
                                            [ngClass]="PurposeType==PurposeTypeEnum.Others?'active-filter':''"
                                            (click)="LoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                                        </div>
                                    </div>
                                    <div class="loan-steps-0">
                                        <div class="loan-text-y">Loan Amount</div>
                                        <div>
                                            <!-- <input type="text" class="form-control box-loan-m" placeholder=""> -->
                                            <input type="text" id="chang" class="value-orange org-val" placeholder=""
                                            oninput="javascript: if (this.value > 25000){this.value = 25000;}" step="500"
                                            min="500" max="25000" #sliderAmount pattern="\d*" (blur)="LoanAmounts($event)"
                                            value="£ {{Amount}}">
                                        </div>
                
                                        <div class="slide-container">
                                            <input type="range" class="width-slider" formControlName="LoanAmount" step="500"
                                            (input)="changeSlider($event,'LoanAmount')"
                                            (change)="changeSlider($event,'LoanAmount')" min="500" max="25000">
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="box-m-1">£500</div>
                                            <div class="box-m-1 margin-new-y">£25000</div>
                                        </div>
                                    </div>
                                    <div class="loan-steps-0">
                                        <div class="loan-text-y">Loan Term</div>
                                       
                                            <div class="value-orange width-y">{{TermYear}}  <span class="space-new" [innerHTML]="TermTypes"> </span></div>
                                       
                                        <div class="slide-container">
                                            <!-- <input type="range" class="width-slider" step="6" min="6" max="120"> -->
                                            <input type="range" class="width-slider" formControlName="LoanTerm" step="6"
                                            (input)="changeSlider($event,'LoanTerm')"
                                            (change)="changeSlider($event,'LoanTerm')" min="6" max="120">
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="box-m-1">6 m</div>
                                            <div class="box-m-1 margin-new-y">10 yrs</div>
                                        </div>
                
                                    </div>
                            
                            </div>
                              

                                <div class="btn-group btn-container">
                                    <div class="text-content">
                                    <!-- <button class="btn button-step" type="submit" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact:true}" (click)="onStarted()" [disabled]="submitted" >
                                    Start my free search<span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span>
                                    </button> -->

                                    <button class="btn button-step" type="button" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"
                                    (click)="onStarted()" [disabled]="submitted"> Start my free search
                                    <span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span>
                                    </button>
                                    </div>
                                    </div>
                                <div class="quote-score">Getting a quote <b>won’t affect</b> your credit score.</div></div>
                        </div>
                        <div class="box-start d-mobile">
                            <div class="loan-purpose">Loan Purpose</div>

                            <div class="d-mobile">
                                <div class="d-flex margin-mobile">

                                    <div class="filter-text"
                                    [ngClass]="PurposeType==PurposeTypeEnum.HomeImprovements?'active-y':''"
                                    (click)="LoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">Home
                                    Improvements</div>
                                    <div class="filter-text"
                                        [ngClass]="PurposeType==PurposeTypeEnum.CarLoan?'active-y':''"
                                        (click)="LoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan</div>
                                  
                                </div>
                                <div class="d-flex">
                                   
                                    <div class="filter-text"
                                    [ngClass]="PurposeType==PurposeTypeEnum.DebtConsolidation?'active-y':''"
                                    (click)="LoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">
                                    Debt Consolidation</div>

                                    <div class="filter-text"
                                        [ngClass]="PurposeType==PurposeTypeEnum.Others?'active-y':''"
                                        (click)="LoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between margin-value">
                                <div class="Loan-Amount">Loan Amount</div>
                                <div class="input-group" id="orgval">
                                        <div class="input-group-text value-orange pading-euro">£</div>
                                    <input type="number" id="chang" class="value-orange new-r"
                                    placeholder=""
                                    oninput="javascript: if (this.value > 25000){this.value = 25000;}"
                                    step="500" min="500" max="25000" #sliderAmount pattern="\d*"
                                    (blur)="LoanAmounts($event)" value="{{Amount}}">
                                </div>
                                
                                
                            </div>

                            <div class="slidecontainer">
                                <input type="range" formControlName="LoanAmount" step="500"
                                    (input)="changeSlider($event,'LoanAmount')"
                                    (change)="changeSlider($event,'LoanAmount')" min="500" max="25000">
                            </div>

                            <div class="d-flex justify-content-between margin-xy">
                                <div class="box-m-1">£500</div>
                                <div class="box-m-1 margin-new-y">£25000</div>
                            </div>

                            <div class="d-flex justify-content-between margin-value">
                                <div class="Loan-Amount">Loan Term</div>
                                <div class="d-flex">
                                    <div class="value-orange">{{TermYear}} <span [innerHTML]="TermTypes"></span></div>
                                 

                                </div>
                            </div>

                            <div class="slidecontainer">
                                <input type="range" formControlName="LoanTerm" step="6"
                                    (input)="changeSlider($event,'LoanTerm')" (change)="changeSlider($event,'LoanTerm')"
                                    min="6" max="120">
                            </div>
                            <div class="d-flex justify-content-between margin-xy">
                                <div class="box-m-1">6 m</div>
                                <div class="box-m-1 margin-new-y">10 yrs</div>
                            </div>

                            <div class="btn-container">
                                <button type="submit" class="btn btn-loan" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact:true}" (click)="onStarted()"
                                    [disabled]="submitted">
                                    Start my free search<span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span></button>
                            </div>
                            <div class="quote-score">Getting a quote <b>won’t affect</b> your credit score.</div>
                        </div>
                    </form>
                </div>
                <div>
                    <div class="mobile-company-text text-company">Compare the best loans from a wide range of leading lenders</div>
                    <div class="container-company-0">
                        <marquee direction="left" scrollamount="5" onmouseover="stop()" onmouseout="start()"
                            height="50">
                            <img src="{{imgSrc}}AA.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}chetwood.svg" alt="company-logo"
                                class="img-fluid company-img">
                            <img src="{{imgSrc}}everyday-loans-logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}hsbc.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Koyo_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}m&s.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Natwest.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}RBS.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}san_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Shawbrook_Bank.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Zopa_Corporate_Logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}TSB_logo_2013.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}OakbrookGroup.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}AA.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}chetwood.svg" alt="company-logo"
                                class="img-fluid company-img">
                            <img src="{{imgSrc}}everyday-loans-logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}hsbc.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Koyo_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}m&s.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Natwest.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}RBS.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}san_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Shawbrook_Bank.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Zopa_Corporate_Logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}TSB_logo_2013.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}OakbrookGroup.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}AA.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}chetwood.svg" alt="company-logo"
                                class="img-fluid company-img">
                            <img src="{{imgSrc}}everyday-loans-logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}hsbc.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Koyo_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}m&s.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Natwest.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}RBS.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}san_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Shawbrook_Bank.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Zopa_Corporate_Logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}TSB_logo_2013.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}OakbrookGroup.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}AA.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}chetwood.svg" alt="company-logo"
                                class="img-fluid company-img">
                            <img src="{{imgSrc}}everyday-loans-logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}hsbc.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Koyo_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}m&s.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Natwest.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}RBS.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}san_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Shawbrook_Bank.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Zopa_Corporate_Logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}TSB_logo_2013.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}OakbrookGroup.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}AA.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}chetwood.svg" alt="company-logo"
                                class="img-fluid company-img">
                            <img src="{{imgSrc}}everyday-loans-logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}hsbc.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Koyo_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}m&s.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Natwest.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}RBS.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}san_logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Shawbrook_Bank.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}Zopa_Corporate_Logo.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}TSB_logo_2013.svg" alt="company-logo"
                                class="company-img img-fluid">
                            <img src="{{imgSrc}}OakbrookGroup.svg" alt="company-logo"
                                class="company-img img-fluid">
                        </marquee>



                    </div>
                </div>

            </div>

        </div>
    </div>
    <div class="d-select">
        <div class="container-company-section container-fluid">
           

            <div class="container-step container-fluid">
                <div class="simple-step">Just 3 simple steps</div>
                <div class="d-flex">
                    <div class="step-1">
                        <img src="{{imgSrc}}icon1.svg" alt="tick-arrow"
                            class="img-step img-fluid">
                        <div class="step-text">Provide Details</div>
                        <div class="text-step">Just tell us a little about yourself, your finances, and your loan needs
                        </div>
                    </div>
                    <img src="{{imgSrc}}arrows1.svg" alt="tick-arrow"
                        class="img-arrow img-fluid">
                    <div class="step-1">
                        <img src="{{imgSrc}}icon2.svg" alt="tick-arrow"
                            class="img-step img-fluid">
                        <div class="step-text">Get Results</div>
                        <div class="text-step">Get the loan results from wide range of lenders in seconds</div>
                    </div>
                    <img src="{{imgSrc}}arrows.svg" alt="tick-arrow"
                        class="img-arrow img-fluid">
                    <div class="step-1">
                        <img src="{{imgSrc}}icon.svg" alt="tick-arrow"
                            class="img-step img-fluid">
                        <div class="step-text">Grab the Deal</div>
                        <div class="text-step">Choose and apply the most suitable loan from the results</div>
                    </div>
                </div>
                <div class="btn-group btn-container">
                    <div class="text-content">
                    <button class="btn button-step" type="submit" (click)="MoveTop()">
                    Start my free search<span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span>
                    </button>
                    </div>
                    </div>
                
            </div>
        </div>
        <div class="container-hassle container-fluid">
            <div class="hassle-section">
                <div class="hassle-text">Hassle-free loans, with higher approval rates</div>
                <div class="d-flex">
                    <div class="box-strip margin-hassle">
                        <img src="{{imgSrc}}simple-fast.png" alt="tick-arrow"
                            nclass="img-fluid">
                    </div>
                    <div class="box-strip">
                        <img src="{{imgSrc}}Best-deals.png" alt="tick-arrow"
                            nclass="img-fluid">
                    </div>
                    <div class="box-strip">
                        <img src="{{imgSrc}}no-hard.png" alt="tick-arrow"
                            nclass="img-fluid">
                    </div>
                    <div class="box-strip">
                        <img src="{{imgSrc}}save-time.png" alt="tick-arrow"
                            nclass="img-fluid">
                    </div>
                </div>
            </div>
        </div>
        <form [formGroup]="QuoteLoanForm" (ngSubmit)="onStarted()">
            <div class="container-loan-y container-fluid">
                <div class="loan-quotes-text">Get a loan quote within 2 minutes</div>
                <div class="d-flex loan-box-y">
                    <div class="loan-steps">
                        <div class="loan-text-y">Loan Purpose</div>
                        <div class="d-flex margin-y">

                             <!-- <div class="filter-text">Home Improvements</div> -->
                             <div class="filter-text"
                             [ngClass]="QuotePurposeType==PurposeTypeEnum.HomeImprovements?'active-filter':''"
                             (click)="GetQuoteLoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">Home
                             Improvements</div>

                            <!-- <div class="filter-text active-y">Car Loan</div> -->
                            <div class="filter-text"
                                [ngClass]="QuotePurposeType==PurposeTypeEnum.CarLoan?'active-filter':''"
                                (click)="GetQuoteLoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan</div>


                         
                        </div>
                        <div class="d-flex">
                           
                               <!-- <div class="filter-text">Debt Consolidation</div> -->
                               <div class="filter-text"
                               [ngClass]="QuotePurposeType==PurposeTypeEnum.DebtConsolidation?'active-filter':''"
                               (click)="GetQuoteLoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">
                               Debt
                               Consolidation</div>

                            <!-- <div class="filter-text">Others</div> -->
                            <div class="filter-text"
                                [ngClass]="QuotePurposeType==PurposeTypeEnum.Others?'active-filter':''"
                                (click)="GetQuoteLoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                        </div>
                    </div>
                    <div class="loan-steps-0">
                        <div class="loan-text-y">Loan Amount</div>
                        <div>
                            <!-- <input type="text" class="form-control box-loan-m" placeholder=""> -->
                            <input type="text" id="chang" class="value-orange org-val" placeholder="" step="500"
                                min="500" max="25000" oninput="javascript: if (this.value > 25000){this.value = 25000;}"
                                #sliderQuoteAmount pattern="\d*" (blur)="LoanAmounts($event)" value="£ {{QuoteAmount}}">
                        </div>

                        <div class="slide-container">
                            <input type="range" class="width-slider" formControlName="QuoteLoanAmount" step="500"
                                min="500" max="25000" (input)="changeSlider($event,'QuoteLoanAmount')"
                                (change)="changeSlider($event,'QuoteLoanAmount')">
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="box-m-1">£500</div>
                            <div class="box-m-1 margin-new-y">£25000</div>
                        </div>
                    </div>
                    <div class="loan-steps-0">
                        <div class="loan-text-y">Loan Term</div>
                       
                            <!-- <div class="form-control box-loan-y box-yrs">3 yrs</div> -->
                            <div class="value-orange width-y">{{QuoteTermYear}} <span class="space-new"
                                    [innerHTML]="QuoteTermTypes"></span></div>
                       
                        <div class="slide-container">
                            <!-- <input type="range" class="width-slider" step="6" min="6" max="120"> -->
                            <input type="range" class="width-slider" formControlName="QuoteLoanTerm" step="6" min="6"
                                max="120" (input)="changeSlider($event,'QuoteLoanTerm')"
                                (change)="changeSlider($event,'QuoteLoanTerm')">
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="box-m-1">6 m</div>
                            <div class="box-m-1 margin-new-y">10 yrs</div>
                        </div>

                    </div>
                </div>
                <div class="btn-group btn-container">
                    <div class="text-content">
                    <button class="btn button-step" type="submit" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact:true}" (click)="getLoanQuote()" [disabled]="submitted" >
                    Start my free search<span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span>
                    </button>
                    </div>
                    </div>
                    <div class="quote-score">Getting a quote <b>won’t affect</b> your credit score.</div>
            </div>
        </form>

        <div class="container-review container-fluid">
            <div class="container-review-step">
                <div class="review-heading">Some stories from our happy customers</div>
                <div class="d-flex">
                    <div class="review-box">
                        <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="review-text">
                            It was so quick to get a loan using Credit Genius.
                            I found it easy to search and get the best loan deals.
                        </div>
                        <img src="{{imgSrc}}review-img-1.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="name-text">Rick Manual Jr</div>
                    </div>

                    <div class="review-box">
                        <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="review-text">
                            I got rejected by several other websites. I got a suitable loan at a low-interest rate. It
                            was simple and hassle-free in Credit Genius. I would recommend it to my friends.
                        </div>
                        <img src="{{imgSrc}}review-img-2.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="name-text">Maria Phoenix</div>
                    </div>

                    <div class="review-box">
                        <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="review-text">
                            Haven’t seen a simple loan website before. I was approved instantly and got the best deal
                            which I didn’t find anywhere else.
                        </div>
                        <img src="{{imgSrc}}review-img-3.svg" alt="tick-arrow"
                            class="img-fluid">
                        <div class="name-text">Marco Maximus</div>
                    </div>
                </div>

            </div>

        </div>
        <div class="container-loan-y container-fluid">

            <div class="heading-loan">Loans Explained</div>
            <div class="para-loan">There are lots of ways to borrow money. A loan is a type of credit that is borrowed
                and
                expected to be paid back over the time you agreed with interest.
                Think about which features are important to you and choose the right type of loan.</div>
            <div class="box-loan-explained">
                <div class="row">
                    <div class="col-4">
                        <div class="box-loan-text">
                            <div class="d-flex">
                             
                                <div class="heading-box">Personal Loans</div>
                            </div>
                            <div class="para-box">Allows you to borrow up to £25,000 and isn’t secured against anything
                                you own.
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="box-loan-text">
                            <div class="d-flex">
                                <div class="heading-box">Car Loans</div>
                            </div>
                            <div class="para-box">Usually offered when you buy a car. Other alternatives could be
                                personal loans
                                & credit cards.</div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="box-loan-text boxb-0">
                            <div class="d-flex">
                                <div class="heading-box">Secured Loans</div>
                            </div>
                            <div class="para-box">Allows you to borrow more at better rates and is secured against
                                something you
                                own.</div>
                        </div>
                    </div>
                </div>
                <div class="divider-loans"></div>
                <div class="row">
                    <div class="col-4">
                        <div class="box-loan-text">
                            <div class="d-flex">
                                <div class="heading-box">Debt Consolidation Loan</div>
                            </div>
                            <div class="para-box">Helps to consolidate all your debt into one loan and can reduce the
                                overall
                                interest you pay.</div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="box-loan-text">
                            <div class="d-flex">
                                <div class="heading-box">Guarantor Loans</div>
                            </div>
                            <div class="para-box">A type of unsecured loan where someone known to you agrees to pay off
                                the debt
                                if you can’t.</div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="box-loan-text boxb-0">
                            <div class="d-flex">
                                <div class="heading-box">Bad Credit Loans</div>
                            </div>
                            <div class="para-box">Usually the interest rates are higher and sometimes you’ll need a
                                guarantor.
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="container-loan container-fluid">
            <div class="bg-bottom">
                <div class="row">
                    <div class="col-7 padding-t">
                        <div class="text-bg-heading">Want to boost your credit score? Sign up with <span>Ooki</span>, its free.</div>
                        <div class="ooki-text">Join Ooki today to:</div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Boost & manage your credit score for FREE</div>
                        </div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Link your bank account to save money</div>
                        </div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Get fairer deals on all financial products</div>
                        </div>

                        <div class="form-container">
                            <div class="input-group">
                                <div class="form-group" id="block-view">
                                    <input type="email" autocomplete="off" [(ngModel)]="EmailToSendInvite"
                                        class="form-control width-01" placeholder="Enter your email">
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-startsaving" type="submit"
                                        (click)="registrationRequest()">Get
                                        Started </button>
                                </div>
                            </div>
                        </div>
                        <div class="policy">Ooki uses bank grade encryption & your privacy is fully protected. We are FCA regulated & ICO compliant.</div>
           
                    </div>
                   <!---<div class="col-5 text-center">

                        <img src="{{imgSrc}}another-one-2x.png" alt="tick-arrow" class="img-webo img-fluid">
               

                    </div>-->
                </div>
            </div>
        </div>
    </div>
    <div class="d-mobile">
        <div class="container-step container-fluid">
            <div class="simple-step">Just 3 simple steps</div>
            <div class="step-1">
                <img src="{{imgSrc}}icon1.svg" alt="tick-arrow" class="img-step img-fluid">
                <div class="step-text">Provide Details</div>
                <div class="text-step">Just tell us a little about yourself, your finances, and your loan needs</div>
            </div>
            <img src="{{imgSrc}}arrows-step.svg" alt="tick-arrow"
                class="img-arrow img-fluid">
            <div class="step-1">
                <img src="{{imgSrc}}icon2.svg" alt="tick-arrow" class="img-step img-fluid">
                <div class="step-text">Get Results</div>
                <div class="text-step">Get the loan results from wide range of lenders in seconds</div>
            </div>
            <img src="{{imgSrc}}arrows-step1.svg" alt="tick-arrow"
                class="img-arrow img-fluid">
            <div class="step-1">
                <img src="{{imgSrc}}icon.svg" alt="tick-arrow" class="img-step img-fluid">
                <div class="step-text">Grab the Deal</div>
                <div class="text-step">Choose and apply the most suitable loan from the results</div>
            </div>
            <div class="button-container"><button type="submit" (click)="MoveTop()" class="btn button-step">
                Start my free search <span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span></button>
            </div>
        </div>
        <div class="hassle-mobile">
            <div class="hassle-mobile-text">Hassle-free loans, with higher approval rates</div>
            <img src="{{imgSrc}}hassle-bg-m.png" alt="tick-arrow" class="img-fluid">
        </div>
        <div class="container-step container-fluid">
            <div class="mobile-loan-text">Get a loan quote within 2 minutes</div>
            <form [formGroup]="QuoteLoanForm">
                <div class="box-start d-mobile">
                    <div class="loan-purpose">Loan Purpose</div>
                    <div class="d-mobile">
                        <div class="d-flex margin-mobile">

                            <div class="filter-text"
                            [ngClass]="QuotePurposeType==PurposeTypeEnum.HomeImprovements?'active-y':''"
                            (click)="GetQuoteLoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">Home
                            Improvements</div>

                            <div class="filter-text" [ngClass]="QuotePurposeType==PurposeTypeEnum.CarLoan?'active-y':''"
                                (click)="GetQuoteLoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan</div>
                            
                        </div>
                        <div class="d-flex">
                           
                            <div class="filter-text"
                                [ngClass]="QuotePurposeType==PurposeTypeEnum.DebtConsolidation?'active-y':''"
                                (click)="GetQuoteLoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">
                                Debt
                                Consolidation</div>
                                
                            <div class="filter-text" [ngClass]="QuotePurposeType==PurposeTypeEnum.Others?'active-y':''"
                                (click)="GetQuoteLoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between margin-value">
                        <div class="Loan-Amount">Loan Amount</div>
                        <div class="input-group" id="orgval">
                                <div class="input-group-text value-orange pading-euro">£</div>
                            <input type="number" id="chang" class="value-orange new-r"
                            placeholder="" oninput="javascript: if (this.value > 25000){this.value = 25000;}"
                            step="500" min="500" max="25000" #sliderQuoteAmount pattern="\d*"
                            (blur)="LoanQuoteAmounts($event)" value="{{QuoteAmount}}">
                        </div>
                    </div>
<div class="slidecontainer">
                        <input type="range" step="500" min="500" max="25000" formControlName="QuoteLoanAmount"
                            (input)="changeSlider($event,'QuoteLoanAmount')"
                            (change)="changeSlider($event,'QuoteLoanAmount')">
                    </div>

                    <div class="d-flex justify-content-between margin-xy">
                        <div class="box-m-1">£500</div>
                        <div class="box-m-1 margin-new-y">£25000</div>
                    </div>

                    <div class="d-flex justify-content-between margin-value">
                        <div class="Loan-Amount">Loan Term</div>
                        <div class="d-flex">
                            <!-- <div class="value-orange">3 years</div> -->
                            <div class="value-orange">{{QuoteTermYear}} <span [innerHTML]="QuoteTermTypes"></span></div>
                         

                        </div>
                    </div>

                    <div class="slidecontainer">
                        <input type="range" formControlName="QuoteLoanTerm" step="6" min="6" max="120"
                            (input)="changeSlider($event,'QuoteLoanTerm')"
                            (change)="changeSlider($event,'QuoteLoanTerm')">

                        <!-- <input type="range" step="6" (input)="changeSlider($event,'LoanTerm')"
                        (change)="changeSlider($event,'LoanTerm')" min="6" max="120"> -->
                    </div>
                    <div class="d-flex justify-content-between margin-xy">
                        <div class="box-m-1">6 m</div>
                        <div class="box-m-1 margin-new-y">10 yrs</div>
                    </div>

                    <div class="btn-container">
                        <button type="submit" class="btn btn-loan" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact:true}" (click)="getLoanQuote()" [disabled]="submitted">
                            Start my free search <span class="icon" aria-hidden="true"><i class="fas fa-arrow-right"></i></span></button>
                    </div>
                    <div class="quote-score">Getting a quote <b>won’t affect</b> your credit score.</div>
                </div>
            </form>
        </div>
        <div class="hassle-mobile">
            <div class="review-heading-mobile">Some stories from our happy and satisfied customers</div>

            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="review-box">
                            <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="review-text">
                                It was so quick to get a loan using Credit Genius.
                                I found it easy to search and get the best loan deals.
                            </div>
                            <img src="{{imgSrc}}review-img-1.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="name-text">Rick Manual Jr</div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="review-box">
                            <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="review-text">
                                I got rejected by several other websites. I got a suitable loan at a low-interest rate.
                                It was simple and hassle-free in Credit Genius. I would recommend it to my friends.
                            </div>
                            <img src="{{imgSrc}}review-img-2.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="name-text">Maria Phoenix</div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="review-box">
                            <img src="{{imgSrc}}icon-review.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="review-text">
                                Haven’t seen a simple loan website before. I was approved instantly and got the best
                                deal which I didn’t find anywhere else.
                            </div>
                            <img src="{{imgSrc}}review-img-3.svg" alt="tick-arrow"
                                class="img-fluid">
                            <div class="name-text">Marco Maximus</div>
                        </div>
                    </div>
                </div>
                <ol class="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
            </div>
        </div>
        <div class="container-step container-fluid">
            <div class="Loans-Explained">Loans Explained</div>
            <div class="loan-text-mobile">There are lots of ways to borrow money. A loan is a type of credit that is
                borrowed and expected to be paid back over the time you agreed with interest. Think about which features
                are important to you and choose the right type of loan.
            </div>
            <div class="box-explained-mobile">
                <div class="heading-text-mobile">Personal Loans</div>
                <div class="heading-para">
                    Allows you to borrow up to £25,000 and isn’t secured against anything you own.
                </div>
                <div class="divider-mobile"></div>
                <div class="heading-text-mobile">Car Loans</div>
                <div class="heading-para">
                    Usually offered when you buy a car. Other alternatives could be personal loans & credit cards.
                </div>
                <div class="divider-mobile"></div>
                <div class="heading-text-mobile">Secured Loans</div>
                <div class="heading-para">
                    Allows you to borrow more at better rates and is secured against something you own.
                </div>
                <div class="divider-mobile"></div>
                <div class="heading-text-mobile">Debt Consolidation Loan</div>
                <div class="heading-para">
                    Helps to consolidate all your debt into one loan and can reduce the overall interest you pay
                </div>
                <div class="divider-mobile"></div>
                <div class="heading-text-mobile">Guarantor Loans</div>
                <div class="heading-para">
                    A type of unsecured loan where someone known to you agrees to pay off the debt if you can’t.
                </div>
                <div class="divider-mobile"></div>
                <div class="heading-text-mobile">Bad Credit Loans</div>
                <div class="heading-para">
                    Usually the interest rates are higher and sometimes you’ll need a guarantor
                </div>




            </div>







        </div>
        <div class="container-loan container-fluid">
            <div class="bg-bottom">
                <div class="row">
                    <div class="col-12 padding-t">
                        <div class="text-bg-heading">Want to boost your credit score? Sign up with <span>Ooki</span>, its free.</div>
                     <div class="text-center">   <img src="{{imgSrc}}mobile2x.png" alt="tick-arrow" class="img-fluid phone-img">
</div>
                        <div class="ooki-text">Join Ooki today to:</div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Boost & manage your credit score for FREE</div>
                        </div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Link your bank account to save money</div>
                        </div>

                        <div class="d-flex">
                            <i class="fas fa-arrow-alt-circle-right"></i>
                            <div class="list-text">Get fairer deals on all financial products</div>
                        </div>

                        <div class="form-container">
                            <div class="input-group">
                                <div class="form-group" id="block-view">
                                    <input type="email" autocomplete="off" [(ngModel)]="EmailToSendInvite"
                                        class="form-control width-01" placeholder="Enter your email">
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-startsaving" type="submit"
                                        (click)="registrationRequest()">Get
                                        Started </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="policy">Ooki uses bank grade encryption & your privacy is fully protected. We are FCA regulated & ICO compliant.</div>


            </div>
        </div>



    </div>
















</div>















<app-footer></app-footer>